import DataTable from "../../components/DataTable";
import { useState, useEffect } from 'react'
import api from '../../config/api'
import { ColDef } from '@material-ui/data-grid';
import { Container } from './styles'
import { Button, TextField, Typography } from "@material-ui/core";
import Selector from "../../components/Selector";
import { zonedTimeToUtc } from 'date-fns-tz';
import { CSVLink } from "react-csv";
import GetAppIcon from '@material-ui/icons/GetApp';



interface Order {
    id: number
    name: string
    account: string
    cpf: string
    user_id: number
    user: User
    customer: string
    affiliated: boolean
    capital: boolean
    branch_id: number
    account_type: string
    order_products: Order_Products[]
    quantity: number
    integralized: boolean
    value: number
    created_at: Date
}

interface Order_Products {
    id: number
    order_id: number
    product_id: number
    quantity: number
    product: Product
    value: number
}

interface Product {
    id: number
    name: string
    description: string
    value: number
    image: string
}

interface User {
    id: number
    name: string
    email: string
    role: string
    branch_id: number
}

interface NormalizedOrder {
    id: number
    order_id: number
    user: string
    user_email: string
    customer: string
    affiliated: string
    capital: string
    account_type: string
    branch_id: number
    product: string
    quantity: number
    value: number
    integralized: string
    tzDate: string,
    tzTime: string
}


interface Branch {
    id: number
    description: string
    created_at: string
}


function Orders() {

    const [branchs, setBranchs] = useState<Branch[]>([])
    const [products, setProducts] = useState<Branch[]>([])

    const [filterBranch, setFilterBranch] = useState<string | undefined>("-1")
    const [filterProduct, setFilterProduct] = useState<string | undefined>("-1")
    const [filterAffiliated, setFilterAffiliated] = useState<string | undefined>("-1")
    const [filterCapital, setFilterCapital] = useState<string | undefined>("-1")
    const [filterDateInit, setFilterDateInit] = useState<string | undefined>()
    const [filterDateEnd, setFilterDateEnd] = useState<string | undefined>()

    const [normalizedList, setNormalizedList] = useState<NormalizedOrder[]>([])
    const [csvList, setCsvList] = useState<string[][]>([])

    const columns: ColDef[] = [
        { field: 'order_id', headerName: 'N Venda', width: 100 },
        { field: 'user', headerName: 'Colaborador', width: 280 },
        { field: 'user_email', headerName: 'Email do Colaborador', width: 280 },
        { field: 'customer', headerName: 'Cliente', width: 280 },
        { field: 'affiliated', headerName: 'Associado', width: 100 },
        { field: 'capital', headerName: 'Capital', width: 100 },
        { field: 'integralized', headerName: 'Integralizado', width: 120 },
        { field: 'account_type', headerName: 'CRM', width: 100 },
        { field: 'branch_id', headerName: 'Agência', width: 90, },
        { field: 'product', headerName: 'Produto', width: 200, },
        { field: 'quantity', headerName: 'QTD', width: 80, },
        { field: 'value', headerName: 'Valor Total', width: 130, },
        { field: 'tzDate', headerName: 'Data', width: 120 },
        { field: 'tzTime', headerName: 'Hora', width: 100 },
    ];


    const optionsArray = [
        {
            id: 0,
            description: 'Não'
        },
        {
            id: 1,
            description: 'Sim'
        },
    ]

    function normalizeJSON(orders: Order[]) {
        const normalizedOrders: NormalizedOrder[] = []

        const auxCsvList = []

        auxCsvList.push([
            'N Venda',
            'Colaborador',
            'Email do colaborador',
            'Cliente',
            'Associado',
            'Capital',
            'Integralizado',
            'CRM',
            'Agência',
            'Produto',
            'QTD',
            'Valor Total',
            'Data',
            'Hora'
        ])

        orders.map((order) => {
            order.order_products.map((order_product) => {

                const timezonedDate = zonedTimeToUtc(order.created_at, 'America/Sao_Paulo');
                const tzTime = timezonedDate.toLocaleTimeString()
                const tzDate = timezonedDate.toLocaleDateString()

                auxCsvList.push([
                    order.id,
                    order.user.name,
                    order.user.email,
                    order.account,
                    order.affiliated ? "Sim" : "Não",
                    order.capital ? "Sim" : "Não",
                    (order.capital && order.account_type === 'old') ?
                    order.integralized ? 'Sim' : 'Não'
                    :
                    'Não Aplicavel',
                    order.account_type === "old" ? "Legado" : "Novo",
                    order.branch_id,
                    order_product.product.name,
                    order_product.quantity,
                    order_product.value,
                    tzDate,
                    tzTime
                ])

                normalizedOrders.push({
                    affiliated: order.affiliated ? "Sim" : "Não",
                    capital: order.capital ? "Sim" : "Não",
                    integralized: (order.capital && order.account_type === 'old') ?
                    order.integralized ? 'Sim' : 'Não'
                    :
                    'Não Aplicavel',
                    branch_id: order.branch_id,
                    tzDate,
                    tzTime,
                    customer: order.account,
                    account_type: order.account_type === "old" ? "Legado" : "Novo",
                    id: order_product.id,
                    order_id: order.id,
                    product: order_product.product.name,
                    quantity: order_product.quantity,
                    user: order.user.name,
                    user_email: order.user.email,
                    value: order_product.value
                })
            })
        })

        setCsvList(auxCsvList)


        return normalizedOrders
    }


    useEffect(() => {
        async function fetch() {

            const auxBranchs = await api.get('/branchs')
            setBranchs(auxBranchs.data.branchs)
            const auxProducts = await api.get('/products')
            setProducts(auxProducts.data.products)
        }
        fetch()
    }, [])

    async function handleSearch() {
        const filter = {
            affiliated: filterAffiliated === "-1" ? undefined : filterAffiliated ? true : false,
            capital: filterCapital === "-1" ? undefined : filterCapital ? true : false,
            branch_id: filterBranch === "-1" ? undefined : filterBranch,
            product_id: filterProduct === "-1" ? undefined : filterProduct,
            start_date: filterDateInit,
            end_date: filterDateEnd
        }

        const auxList = await api.get('/orders',
            {
                params: {
                    ...filter
                },

            })

        console.log(auxList.data.orders)

        setNormalizedList(normalizeJSON(auxList.data.orders))
    }


    function handleClean() {
        window.location.reload();
    }

    function handleFilterBranch(e: React.ChangeEvent<HTMLInputElement>) {
        setFilterBranch(e.target.value)
    }

    function handleFilterProduct(e: React.ChangeEvent<HTMLInputElement>) {
        setFilterProduct(e.target.value)
    }

    function handleFilterAffiliated(e: React.ChangeEvent<HTMLInputElement>) {
        setFilterAffiliated(e.target.value)
    }
    function handleFilterCapital(e: React.ChangeEvent<HTMLInputElement>) {
        setFilterCapital(e.target.value)
    }

    function handleFilterDateInit(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(e.target.value)
        setFilterDateInit(e.target.value)
    }
    function handleFilterDateEnd(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(e.target.value)
        setFilterDateEnd(e.target.value)
    }

    return (
        <Container>
            {
                <>
                    <Typography variant="h4" style={{ fontWeight: 600 }}>
                        Configurações de busca
                    </Typography>

                    <div className="search-form">

                        <Selector data={optionsArray} placeholder={'Associado'} value={String(filterAffiliated)} handleChange={handleFilterAffiliated} identifier={'description'} />
                        <Selector data={optionsArray} placeholder={'Capital'} value={String(filterCapital)} handleChange={handleFilterCapital} identifier={'description'} />
                        <Selector data={branchs} placeholder={'Agência'} value={filterBranch} handleChange={handleFilterBranch} identifier={'description'} />
                        <Selector data={products} placeholder={'Produto'} value={filterProduct} handleChange={handleFilterProduct} identifier={'name'} />
                        <TextField
                            label="Desde"
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={filterDateInit}
                            onChange={handleFilterDateInit}
                            style={{ marginRight: 10, marginLeft: 10 }}
                        />
                        <TextField
                            label="Até"
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={handleFilterDateEnd}
                            style={{ marginRight: 10, marginLeft: 10 }}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ height: 50, width: 150, marginTop: 20, marginBottom: 20 }}
                            onClick={handleClean}
                        >
                            Limpar
                        </Button>


                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ height: 50, width: 150, marginTop: 20, marginBottom: 20 }}
                            onClick={handleSearch}
                        >
                            Buscar
                        </Button>
                        {
                            normalizedList.length > 0 &&
                            <CSVLink data={csvList} style={{ textDecoration: 'none' }} filename="Sicredi-Store-Relatório">
                                <Button color="primary" variant="contained" style={{ height: 50, width: 150, marginTop: 20, marginBottom: 20, marginLeft: 20 }}>
                                    <GetAppIcon fontSize="small" />
                                    Exportar
                                </Button>
                            </CSVLink>

                        }
                    </div>
                    <Typography variant="h4" style={{ marginBottom: 20 }} >
                        Lista de vendas
                    </Typography>
                    <DataTable
                        columns={columns}
                        rows={normalizedList}


                    />

                </>
            }
        </Container>
    );
}

export default Orders